import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./HeroSection-SmoothSwap.css";

const HeroSectionSmoothSwap = () => {
  const sliderData = [
    { id: 1, img: "assets/images/event-banner/meetup-2026-img1.png" },
    { id: 2, img: "assets/images/event-banner/meetup-2026-img2.png" },
    { id: 3, img: "assets/images/event-banner/meetup-2026-img3.png" },
    { id: 4, img: "assets/images/event-banner/meetup-2026-img4.png" },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [sliderData.length]);

  const currentSlide = sliderData[currentIndex];

  return (
    <section className="hero-theme-wrapper">
      {/* Background Smooth Slider - Height Fix Wrapper for Mobile Stacking */}
      <div className="hero-slider-viewport">
        <AnimatePresence>
          <motion.img
            key={currentIndex}
            src={currentSlide.img}
            alt="MSB Event"
            className="hero-cinematic-bg"
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2, ease: "easeInOut" }}
          />
        </AnimatePresence>
      </div>

      {/* Theme Overlays - Hidden on Mobile via CSS */}
      <div className="dark-overlay" />
      <div className="bottom-white-fade" />

      {/* Hero Content - Image Logo Overlay */}
      <motion.div 
        className="hero-overlay-content"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 1 }}
      >
        <h1 className="hero-main-title">
          Thank you, members,<br /> for a great evening
        </h1>
        <div className="hero-info-row">
          <span className="hero-subtitle">Members meet-up 2026</span>
          <div className="hero-divider"></div>
          <div className="hero-sponsor-box">
            <span className="sponsor-label">co-sponsored by</span>
            <img
              src="assets/images/discussion-panalist/cj-logo-black.svg"
              alt="Clear Junction"
              className="sponsor-logo-img "
            />
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSectionSmoothSwap;
